import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Link } from 'react-router-dom';

import { NAVIGATE_PATH as PATH } from '../../../helpers/constants';
import { getOpsCasePage } from '../../../requests/opsCases';
import { Card } from '../ui';

/** Cases on the program's classes, open and closed (Elizabeth, 2026-09-25). */
const ProgramCases: React.FC<{ programId: string }> = ({ programId }) => {
  const { data } = useQuery({
    queryKey: ['opsProgramCases', programId],
    queryFn: () => getOpsCasePage({ programId, all: true, page: 1 }),
  });
  const items = data?.items ?? [];
  return (
    <Card title={`Related cases · ${data?.total ?? 0}`}>
      <div className="px-5 py-3 text-sm">
        {items.length === 0 ? (
          <span className="text-gray-bold">
            No case on this program's classes.
          </span>
        ) : (
          <ul className="divide-y divide-white-three">
            {items.slice(0, 20).map((c) => (
              <li key={c.id} className="py-1.5">
                <Link
                  className="hover:text-blue-primary hover:underline"
                  to={`${PATH.opsCases}?id=${c.id}`}
                >
                  <span className="text-xs text-gray-bold">
                    {c.createdDate?.slice(0, 10)} · {c.status}
                    {c.className ? ` · ${c.className}` : ''} ·{' '}
                  </span>
                  {c.subject ?? '(no subject)'}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Card>
  );
};

export default ProgramCases;
